import { getDatasetColors, getDatasetBorderWidth, IChartJsDatasetStyles } from 'src/commons/chartjs'
import { colors } from 'src/theme'

export const DEFAULT_COLORS = [
  colors.blue,
  colors.green,
  colors.yellow,
  colors.orange,
  colors.red,
  colors.pink,
  colors.purple,
  colors.grey,
]

export const DEFAULT_DATASET_STYLES: IChartJsDatasetStyles[] = DEFAULT_COLORS.map((colorHex: string) => ({
  ...getDatasetColors(colorHex),
  ...getDatasetBorderWidth(),
}))
